import React from 'react';
import Projects from '../components/UI/Projects';

const ProjectsPage = () => {
  return (
    <div className="projects-page">
      <Projects />
    </div>
  );
};

export default ProjectsPage; 